import axios from "axios"

const state = {
    user: {
        company: {}
    }
}

const getters = {
    currentUserSubscriptionExpired(state) {
        if (state.user.subscription_expired)
            return state.user.subscription_expired

        return false

    }
}

const actions = {
    login( {}, user) {
        
    },

    getCurrentUser( {commit, dispatch}, data) {
        axios.get("/api/current-user")
        .then(response => {
            commit('setUser', response.data);
        })
        .catch(error => {
            if (error.response.status === 401)
                dispatch('logout')
            

        })
    },

    logout( {}, user) {
        localStorage.removeItem('access-token')
        axios.post("/logout")
        .catch(error => { console.log(error)})
        .finally(() => { window.location.replace('/login') })
    }

}

const mutations = {
    setUser(state, data) {
        state.user = data
        //console.log(data)
    },

    clearUser(state) {
        state.user = { company: { } }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}